<div class="autowcont allpads m-top-ii">
    <div class="basicrow f-reg f-black roboto-r">
        <div class="basicrow f-big">
            Pago de Recarga
        </div>
        <div class="dts-rcrg m-top-ii text-center">
            <div class="left-number">
                <div class="basicrow">
                    <span class="roboto-b">N&uacute;mero de T&eacute;lefono</span><br />
                    <span class="f-big roboto-b">{{this.subscriber}}</span>
                </div>
            </div>
            <div class="right-number">
                <div class="basicrow l-pline-i">
                    <span class="roboto-b">Monto a Pagar</span><br />
                    <span class="f-lsemi roboto-b f-red">{{this.totalPagar | currency}}</span>
                </div>
            </div>
        </div>
        <div class="basicrow m-top-i">
            <div class="logline full"></div>
        </div>
        <div class="basicrow roboto-r text-center">
            <div class="shortcont">
                <div class="basicrow m-top-i">
                    <div class="basicrow roboto-b f-bmed">
                        Datos de la Tarjeta
                    </div>
                    <form id="list-card-form">
                        <div class="cardcont">
                            <div class="basicrow roboto-b f-bmed padding-top2">
                                Selecione método de pago:
                            </div>
                            <div>
                                <div>
                                    Pagar con Ath:
                                </div>
                                <div class="card-box">
                                    <div class="basicrow marg-cards text-center ajusteTarjeta" (click)="this.changeTypePayment('ATH');this.updcardValues(typePayment2.id,typePayment2.type,'DBT')" *ngFor="let typePayment2 of this.typePayment; let i = index">
                                        <div class="card-select" *ngIf="typePayment2.type=='ATH'">
                                            <input type="radio" name="card" id="card_ath{{typePayment2.id}}" value="{{typePayment2.id}}_{{typePayment2.type}}_DBT">
                                            <label for="card_ath{{typePayment2.id}}">
                                                <img class="ph-logo" src="{{typePayment2.url}}" alt="">
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div>
                                    Pagar con Tarjeta Débito:
                                </div>
                                <div class="card-box">
                                    <div class="basicrow marg-cards text-center ajusteTarjeta" (click)="this.changeTypePayment('TDD');this.updcardValues(typePayment2.id,typePayment2.type,'TDD')" *ngFor="let typePayment2 of this.typePayment; let i = index">
                                        <div class="card-select" *ngIf="typePayment2.type=='Visa' || typePayment2.type=='Master'">
                                            <input type="radio" name="card" id="card_tdd{{typePayment2.id}}" value="{{typePayment2.id}}_{{typePayment2.type}}_TDD">
                                            <label for="card_tdd{{typePayment2.id}}">
                                                <img class="ph-logo" src="{{typePayment2.url}}" alt="">
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div>
                                    Pagar con Tarjeta Crédito:
                                </div>
                                <div class="basicrow marg-cards text-center ajusteTarjeta" (click)="this.changeTypePayment('TDC');this.updcardValues(typePayment2.id,typePayment2.type,'TDC')" *ngFor="let typePayment2 of this.typePayment; let i = index">
                                    <div class="card-box">
                                        <div class="card-select" *ngIf="typePayment2.type!='ATH'">
                                            <input type="radio" name="card" id="card_tdc{{typePayment2.id}}" value="{{typePayment2.id}}_{{typePayment2.type}}_TDC">
                                            <label for="card_tdc{{typePayment2.id}}">
                                                <img class="ph-logo" src="{{typePayment2.url}}" alt="">
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="basicrow m-top-i">
                        <label class="label-f">
                            &#42; Nombre y Apellido
                        </label>
                        <input placeholder="NOMBRE COMPLETO" class="inp-f" [(ngModel)]="this.NameOnCard" value="" maxlength="30">
                    </div>
                    <div class="basicrow m-top-i">
                        <label class="label-f">
                            &#42; N&uacute;mero de Tarjeta
                        </label>
                        <input [appOnlyNumber]  placeholder="NÚMERO DE TARJETA" class="inp-f" [(ngModel)]="this.idNroTejeta" value="" maxlength="17" required numbers-only>
                    </div>
                    <div class="basicrow m-bott-ii">
                        <div class="left-card m-top-i">
                            <label class="label-f">
                                &#42; Vencimiento de Tarjeta
                            </label>
                            <div class="basicrow">
                                <div class="month-card">
                                    <div class="exprdtitle roboto-b vcenter">
                                        <div class="tabcell">
                                            Mes
                                        </div>
                                    </div>
                                    <select [(ngModel)]="this.fechaExp1" (change)="this.updmonth(this.fechaExp1)"
                                        class="sel-f exprdsize"
                                        style="background-image:url(/assets/images/selectabarrw.png)">
                                        <option *ngFor="let month of this.meses" [ngValue]="month">
                                            {{month.label}}</option>
                                    </select>
                                </div>
                                <div class="year-card h-mtop-iv">
                                    <div class="exprdtitle roboto-b vcenter">
                                        <div class="tabcell">
                                            A&ntilde;o
                                        </div>
                                    </div>
                                    <select [(ngModel)]="this.fechaExp2" (change)="this.updyear(this.fechaExp2)" class="sel-f exprdsize" style="background-image:url(/assets/images/selectabarrw.png)">
                                        <option *ngFor="let year of this.yearList" [ngValue]="year">
                                            {{year.label}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="right-card m-top-i" id="idCodeCVV">
                            <label class="label-f">
                                &#42; C&oacute;digo de Seguridad (CVV)
                            </label>
                            <input [appOnlyNumber] type="password" class="inp-f" maxlength="4" [(ngModel)]="this.cvNum" autocomplete="off" value="" placeholder="CÓDIGO DE SEGURIDAD (CVV)">
                        </div>
                        <div class="codPostal1">
                            <label class="label-f">
                                &#42; C&oacute;digo Postal
                            </label>
                            <input [appZipCode] class="inp-f2" maxlength="5" [(ngModel)]="this.zipcode"  placeholder="CÓDIGO POSTAL" >
                        </div>
                    </div>
                    <div class="basicrow m-top-i" style="padding: 0px 0px 20px 0px;">
                        <label class="basicrow roboto-b f-bmed">
                            Dirección Postal de la Tarjeta
                        </label>
                    </div>
                    <div class="basicrow">
                        <div *ngFor="let prepaidPaymentAddress2 of this.prepaidPaymentAddress; let i = index">
                            <div id="optionDir_{{i}}" class="mnts-rcrg2" (click)="this.optionDir(i,prepaidPaymentAddress2.address,prepaidPaymentAddress2.zipcode)">
                                <div class="checkrcrg checkrcrg-b">
                                    <input type="radio" name="radioG2" id="checkDir_{{i}}" class="css-radio">
                                    <label for="radioG2" class="css-label3 radGroup1"></label>
                                </div>
                                {{prepaidPaymentAddress2.address}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="basicrow m-top-i">
                <div class="logline full"></div>
            </div>
            <div class="basicrow m-top-i m-bott-ii">
                <a class="btns red def-i pull-right vcenter" (click)="this.payRecharge()">
                    <span class="tabcell">
                        Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </a>
                <a class="btns gray def-i pull-left vcenter" (click)="this.cancelPrepaidRecharge()">
                    <span class="tabcell">
                        Cancelar
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>
